import PerformanceArrow from 'src/assets/icons/PerformanceArrow';
import { Typography } from '@navi/web-ui/lib/primitives';
import { LevelIcon } from 'src/assets/icons/LevelIcon';
import { formatAmount, shortNumberNotation } from 'src/utils/commonUtils';
import {
  LEVEL_HEIGHT,
  levelColorsList,
  levelConstructListBEType,
  levelConstructListType,
  MAX_LEVEL_GUARD_PERCENTAGE,
  MIN_LEVEL_GUARD_PERCENTAGE
} from './constant';
import styles from './AgentProgressMeter.module.scss';
import cx from 'classnames';

const getPercentageValue = (
  levelConstruct: levelConstructListType,
  currentCashCollected: number,
  maxLevel: number
) => {
  if (!levelConstruct || !currentCashCollected) return 0;
  const percentage = Math.round(
    (Math.abs(currentCashCollected - levelConstruct.levelLowerLimit) /
      (levelConstruct.levelUpperLimit - levelConstruct.levelLowerLimit)) *
      100
  );
  if (maxLevel === levelConstruct.level && percentage > MAX_LEVEL_GUARD_PERCENTAGE)
    return MAX_LEVEL_GUARD_PERCENTAGE;
  if (1 === levelConstruct.level && percentage < MIN_LEVEL_GUARD_PERCENTAGE)
    return MIN_LEVEL_GUARD_PERCENTAGE;

  if (percentage > 100) return 100;
  if (percentage < 0) return 0;
  if (isNaN(percentage)) return 0;

  return percentage;
};

const generateDivForLevels = (
  levelConstructList: Array<levelConstructListType>,
  currentLevel: number,
  cashCollected: number,
  maxLevel: number,
  fontStyle?: string,
  iconStyle?: string,
  parentStyle?: string
) => {
  const div = [];
  for (let i = 0; i < maxLevel; i++) {
    div.push(
      <div style={{ height: LEVEL_HEIGHT }} className={cx(styles.level, parentStyle)} key={i}>
        <div className={styles.levelIcon}>
          <LevelIcon fontClassName={iconStyle} level={i + 1} color={levelConstructList[i]?.color} />
        </div>
        <div className={styles.levelLine} />
        <span className={cx(styles.maxLimitText, fontStyle)}>
          <Typography variant="p3" style={{ cursor: 'default' }}>
            <span
              title={`${formatAmount(levelConstructList[i].levelUpperLimit)}`}
            >{`₹${shortNumberNotation(levelConstructList[i].levelUpperLimit)}`}</span>
          </Typography>
        </span>
        {i === currentLevel - 1 ? (
          <PerformanceArrow
            style={{
              bottom: `${getPercentageValue(
                levelConstructList[currentLevel - 1],
                cashCollected,
                maxLevel
              )}%`
            }}
            className={cx(styles.performanceArrow)}
          />
        ) : null}
      </div>
    );
  }
  return div;
};

interface AgentProgressMeterProps {
  currentLevel: number;
  cashCollected: number;
  levelConstructList: Array<levelConstructListBEType>;
  fontStyle?: string;
  iconStyle?: string;
  parentStyle?: string;
  maxLevel: number;
}

const AgentProgressMeter = (props: AgentProgressMeterProps) => {
  const {
    currentLevel, //eslint-disable-line
    levelConstructList, //eslint-disable-line
    cashCollected, //eslint-disable-line
    fontStyle, //eslint-disable-line
    iconStyle, //eslint-disable-line
    parentStyle, //eslint-disable-line
    maxLevel //eslint-disable-line
  } = props;
  const PARENT_HEIGHT = `${maxLevel * parseInt(LEVEL_HEIGHT)}px`;
  //eslint-disable-next-line
  const levelInfusedWithColors = levelConstructList?.map((levelConstruct, index) => {
    const level = levelConstruct.level;
    const levelLowerLimit = levelConstruct.levelLowerLimit;
    const levelUpperLimit = levelConstruct.levelUpperLimit;
    const color = levelColorsList[index];
    return {
      level,
      levelLowerLimit,
      levelUpperLimit,
      color
    };
  });
  const renderDiv = generateDivForLevels(
    levelInfusedWithColors,
    currentLevel,
    cashCollected,
    maxLevel,
    fontStyle,
    iconStyle,
    parentStyle
  );
  return (
    <div style={{ height: PARENT_HEIGHT }} className={styles.parent}>
      {renderDiv}
    </div>
  );
};

export default AgentProgressMeter;
